/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import { Checkbox } from '@atlaskit/checkbox';
import { useArchiveIssueActions } from '../../../../controllers/main.tsx';

type Props = {
	isChecked: boolean;
	issueId: string;
	pageNumber: number;
	isDisabled?: boolean;
};

export const SelectCell = memo(({ isChecked, issueId, pageNumber, isDisabled }: Props) => {
	const { selectIssue, deselectIssue } = useArchiveIssueActions();

	const onChange = () => {
		if (!isChecked) {
			selectIssue({ issueId, pageNumber });
		} else {
			deselectIssue({ issueId, pageNumber });
		}
	};

	return (
		<div css={selectCellStyles}>
			<Checkbox
				isChecked={isChecked}
				onChange={onChange}
				value="Archives table checkbox"
				name="archives-table-checkbox"
				isDisabled={isDisabled}
			/>
		</div>
	);
});

const selectCellStyles = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
